// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.impact-proposal-details .table-header-cell i {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/DtcoOverviewPage/ImpactProposalModal/components/ImpactProposalTable.scss"],"names":[],"mappings":"AACK;EACG,aAAA;AAAR","sourcesContent":[".impact-proposal-details .table-header-cell {\n     i {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
